import React from 'react';
import { defaultBreadcrumb, defaultBreadcrumbSpanish } from '../../fragments/texas-node';
import Breadcrumbs from '../Generics/Breadcrumbs';
import { translateLanguage } from '../utils/UtilityFunctions';

import './Hero.scss';

export default function SearchHero({ language }: { language: string }) {
  return (
    <div className="wrapper">
      <Breadcrumbs
        breadcrumb={language == 'en' ? defaultBreadcrumb : defaultBreadcrumbSpanish}
        currentPageTitle="Search"
      />
      <div className="container w-1/2">
        <h1 className="search-hero__title">
          {translateLanguage(language, 'Search Results', 'Resultados de Busqueda')}
        </h1>
      </div>
    </div>
  );
}
